















import { Component, Prop, Vue } from 'vue-property-decorator';

// Schema Assumption: instructions is simple Array of Strings

@Component
export default class InstructionList extends Vue {
  @Prop({ type: Array, required: true }) readonly instructions!: string[];

  formatInstruction(instruction: string): string {
    return instruction;
  }
}
